import React from "react";
import { string } from "prop-types";
import translate from "../../../translate";

import "./support-quint.m.css";

const SupportQuint = ({ publisherName }) => {
  const halndleClick = () => {
    window.localStorage.setItem("sym_initiate_position", "Below the Article");
  };

  return (
    <a href="https://www.thequint.com/plan-selection" target="_blank" rel="nofollow" className="support-the-quint">
      <div styleName="support-quint">
        <div styleName="text">
          <h2>{translate(publisherName, "empower_independent_journalism")}</h2>
          <h2>{translate(publisherName, "because_the_truth_is_worth_it")}</h2>
        </div>
        <div styleName="support-amount">
          <div styleName="select-amount">
            <span styleName="label-text">{translate(publisherName, "select_amount")}</span>
            <div styleName="amount-buttons">
              <button styleName="button active">500</button>
              <button styleName="button">1800</button>
              <button styleName="button">5000</button>
            </div>
          </div>
          <div styleName="support-button-wrapper">
            <button className="support-the-quint" styleName="support-button" onClick={halndleClick}>
              {translate(publisherName, "support_the_quint")}
            </button>
          </div>
        </div>
      </div>
    </a>
  );
};

SupportQuint.propTypes = {
  publisherName: string,
};

export default SupportQuint;
